import { EP_REACT_PROPS_OBSERVABLE_OBJECT } from '../observable-object';
import { type ObservableObject } from '../observable-object/ObservableObject';
import type { IframeElement, IframePassThroughProps } from './IframeElementType';

type WindowWithObservableObject = Window & {
	[EP_REACT_PROPS_OBSERVABLE_OBJECT]?: ObservableObject<IframePassThroughProps>;
};

export const getIframeObservable_DO_NOT_USE = <Props extends IframePassThroughProps>():
	| ObservableObject<Props>
	| undefined =>
	((window.frameElement as IframeElement)?.[EP_REACT_PROPS_OBSERVABLE_OBJECT] ||
		(window as WindowWithObservableObject)[EP_REACT_PROPS_OBSERVABLE_OBJECT]) as
		| ObservableObject<Props>
		| undefined;
